import {
  Header,
  LandingPageWrapper,
  Title,
} from '@/themes/globalStyles';

interface StoppedPageComponentProps {
  backgroundColor: string;
  textColor: string;
  title: string;
}

export const StoppedPageComponent = ({
  backgroundColor,
  textColor,
  title,
}: StoppedPageComponentProps) => (
  <LandingPageWrapper
    backgroundcolor={backgroundColor}
  >
    <Header
      backgroundcolor={backgroundColor}
      isActionTaken={false}
      textcolor={textColor}
    >
      <Title>{title}</Title>
    </Header>
  </LandingPageWrapper>
);
